export enum CompetitionCategoryType {
	FreestyleOpen = "FreestyleOpen",
	FreestyleStarters = "FreestyleStarters",
	QuadrupedMen = "QuadrupedMen",
	QuadrupedWomen = "QuadrupedWomen",
	Sptf1 = "Sptf1",
	Sptf2 = "Sptf2",
	DogDartbee = "DogDartbee",
	ParalelTimeTrial = "ParalelTimeTrial",
}
